import bootstrap from "../../../../assets/img/tech/bootstrap.png";
import css from "../../../../assets/img/tech/css.png";
import flask from "../../../../assets/img/tech/flask.png";
import git from "../../../../assets/img/tech/git.png";
import html5 from "../../../../assets/img/tech/html5.png";
import javascript from "../../../../assets/img/tech/javascript.png";
import jest from "../../../../assets/img/tech/jest.png";
import python from "../../../../assets/img/tech/python.png";
import react from "../../../../assets/img/tech/react.png";
import sass from "../../../../assets/img/tech/sass.png";
import typescript from "../../../../assets/img/tech/typescript.png";
import mongo from "../../../../assets/img/tech/mongo.png";
import mongoose from "../../../../assets/img/tech/mongoose.png";
import node from "../../../../assets/img/tech/node.png";
import mysql from "../../../../assets/img/tech/mysql.png";
import sequelize from "../../../../assets/img/tech/sequelize.png";
import redux from "../../../../assets/img/tech/redux.png";
import tailwind from "../../../../assets/img/tech/tailwind.png";
import material from "../../../../assets/img/tech/material.png";
import reacttesting from "../../../../assets/img/tech/react-testing.png";
import express from "../../../../assets/img/tech/express.png";
import adobePS from "../../../../assets/img/tools/adobe-ps.png";
import adobeXD from "../../../../assets/img/tools/adobe-xd.png";
import figma from "../../../../assets/img/tools/figma.png";
import jira from "../../../../assets/img/tools/jira.png";
import notion from "../../../../assets/img/tools/notion.png";
import postman from "../../../../assets/img/tools/postman.png";

export const SkillSet = [
  { src: html5, title: "HTML5" },
  { src: css, title: "CSS3" },
  { src: javascript, title: "Javascript" },
  { src: typescript, title: "Typescript" },
  { src: react, title: "React" },
  { src: redux, title: "Redux" },
  { src: node, title: "NodeJS" },
  { src: express, title: "Express" },
  { src: mongo, title: "MongoDB" },
  { src: mongoose, title: "Mongoose" },
  { src: mysql, title: "MySQL" },
  { src: sequelize, title: "Sequelize" },
  { src: sass, title: "SASS" },
  { src: tailwind, title: "Tailwind CSS" },
  { src: material, title: "Material UI" },
  { src: bootstrap, title: "Bootstrap" },
  { src: python, title: "Python" },
  { src: flask, title: "Flask" },
  { src: git, title: "Git" },
  { src: jest, title: "Jest" },
  { src: reacttesting, title: "React Testing Library" },
];

export const Tools = [
  { src: adobePS, title: "Adobe Photoshop" },
  { src: adobeXD, title: "Adobe XD" },
  { src: figma, title: "Figma" },
  { src: postman, title: "Postman" },
  { src: jira, title: "Jira" },
  { src: notion, title: "Notion" },
];
